import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject, DOCUMENT } from '@angular/core';
import { getCookieValue } from '../helpers';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const document = inject(DOCUMENT);

  const token = getCookieValue(document.cookie, 'access_token') || '';
  const clonedRequest = req.clone({
    setHeaders: {
      'X-metaportal-token': `${token}`,
    },
  });

  return next(clonedRequest);
};
